// @flow

import * as React from 'react';

import { useParams } from 'react-router-dom';
import { compose } from 'redux';

import { withPageMeta } from '@gandi/app-runner';
import { needsAuth } from '@gandi/authentication';
import { selectIsFetchingOneOrder } from '@gandi/billing';
import { useTranslator } from '@gandi/translate';

import { Base, Block, BlockContent, BlockHeading, Button } from '@gandi/ui';

import { useAppSelector } from 'src/hooks/useAppSelector';

import { useCartSummaryContext } from '../Layout/context/CartSummary';
import { selectIsAppWorking } from '../modules/app';

import OrderError from './components/OrderError';
import { selectOrderError } from './modules';

type Params = {
  cartId: string,
};

function GenerateProforma() {
  const params = useParams<Params>();

  const { orderId } = useCartSummaryContext();

  const orderError = useAppSelector(
    state => !!orderId && selectOrderError(state, { orderId }),
  );

  const isAppWorking = useAppSelector(selectIsAppWorking);
  const isFetchingOrder = useAppSelector(state =>
    // $FlowFixMe[incompatible-call]
    selectIsFetchingOneOrder(state, { orderId }),
  );

  const loading = isAppWorking || isFetchingOrder;

  const { __ } = useTranslator();

  if (!!orderId && orderError) {
    return <OrderError orderId={orderId} />;
  }

  return (
    <>
      <Block padding="small" marginBottom="base">
        <BlockHeading>{__('Generate a proforma and pay later')}</BlockHeading>
        <BlockContent>
          <Base margin="none" marginBottom="none" tagname="p">
            {__(
              'If you need to validate your cart with your organization first, you can generate a proforma and pay later. ',
            )}
          </Base>

          <Base margin="none" marginBottom="small" tagname="p">
            {__('To do this, click on Generate ProForma.')}
          </Base>
        </BlockContent>
      </Block>

      <Button
        disabled={loading}
        kind="outline"
        to={`/cart/${params.cartId}/overview`}
        marginBottom="base"
      >
        {__('Back to Cart')}
      </Button>
    </>
  );
}

export default (compose(
  withPageMeta(args => ({
    title: args.__('Generate a pro forma invoice - Gandi.net'),
  })),
  needsAuth,
)(GenerateProforma): React.ComponentType<{}>);
